<template>
  <div class="booklistPage">
    <v-menu :class="{'navbg':mode==0}"></v-menu>
    <div class="pagebg" :class="{'modebg':mode==0}">
      <div class="videoage">
        <div class="bread_nav">
          <div class="bread_item">
            <ul class="left">
              <router-link :class="{'navcolor':mode==0}" class="left tagli index" :to="{name:'index'}" tag="li" active-class="active">首页&nbsp; &gt&nbsp;</router-link>
              <router-link :class="{'navcolor':mode==0}" class="left tagli" :to="{name:'pcBookList'}" tag="li" active-class="active">心密书库&nbsp; &gt&nbsp;</router-link>
              <router-link :class="{'navcolor':mode==0}" class="left tagli" :to="{name:'pcbookdetail'}" tag="li" active-class="active">心密书库</router-link>
            </ul>
            <div class="clear clearfix"></div>
          </div>
        </div>
        <div class="seeting">
          <div class="settxt left" :class="{'set2':mode==0}">设置</div>
          <div class="fonttype left" :class="{'fonttype1':mode==0}">字体</div>
          <div class="fonttype_opt left" :class="{'select':fontmode==1}" @click="setFontType(1)">简体</div>
          <div class="fonttype_opt left " :class="{'select':fontmode==2}"  @click="setFontType(2)">繁体</div>
          <div class="font-size_txt left" :class="{'fonttype1':mode==0}">字体大小</div>
          <div class="set-font-size left">
            <input type="number" v-model="fontSize" min="12" max="50" class="left" @input="setFontSize"/>
            <div class="dw">px</div>
          </div>
          <div class="font-size_txt left" :class="{'fonttype1':mode==0}">文字行距</div>
          <div class="set-font-size left">
            <input type="number" step="0.2" v-model="fontRate" @input="setLineHeight" min="0.5" max="5" class="left"/>
            <div class="dw">倍</div>
          </div>
          <div class="fonttype left" :class="{'fonttype1':mode==0}">阅读模式</div>
          <div class="fonttype_opt read-mode left" :class="{'select':mode==1}" @click="setMode(1)">白天模式</div>
          <div class="fonttype_opt read-mode left" :class="{'select':mode==0}"  @click="setMode(0)">夜间模式</div>
          <!--<div class="download right" :class="{'down2':mode==0}">-->
            <!--<span :class="{'fonttype1':mode==0}">下载</span>-->
          <!--</div>-->
          <div class="clear clearfix"></div>
        </div>
        <div class="book-content">
          <div class="left chapter">
            <div class="bookimg">
              <img :src="bookinfo.cover_img" :alt="bookinfo.className" :title="bookinfo.className">
            </div>
            <div class="list_txt" :class="{'color2':mode==0}">目录</div>
           <div class="chaptlist">
             <vuescroll :ops="ops" style="width:100%;" class="vuescroll">
               <ul class="">
                 <li class="textover" @click="changeChapt(item)" :class="{'active':item.id==bookinfo.id}" v-for="item in bookData">
                   <span class="textover" :class="{'color2':mode==0}">{{item.title}}</span>
                 </li>
               </ul>
             </vuescroll>
           </div>
          </div>
          <div class="left bookmain">
            <div class="file-title" ﻿:style="{color:fontColor}">{{bookinfo.title}}</div>
            <div class="author" ﻿:style="{color:fontColor}">
             {{bookinfo.author}}
              <div class="date right" ﻿:style="{color:fontColor}">{{bookinfo.create_at}}</div>
              <div class="clear clearfix"></div>
            </div>
            <div class="book-content-txt">
              <vuescroll :ops="ops" ref="vs" >
                <div class="filedom" ﻿:style="{fontSize: `${fontSize}px`,lineHeight:`${lineHeight}px`,color:fontColor}" ref="file" v-html="bookinfo.content"></div>
              </vuescroll>

            </div>
          </div>
          <div class="clear clearfix"></div>
        </div>
      </div>
    </div>
    <mode v-if="loadMode"></mode>
    <!--<div @click="getposition" style="position: fixed;top:50px;left:50px;z-index:999;">获取</div>-->
    <v-footer></v-footer>
  </div>
</template>

<script>

  import mode from '@/components/bg/mode'
  import vuescroll from 'vuescroll'
  import { traditionalized, simplized, dateToStr } from '../../../../static/utils/utils'
    export default {
        name: "detail",
        components:{mode,vuescroll},
        data() {
            return {
              loadMode:true,
              bookData:[],
              ops: {
                vuescroll: {},
                scrollPanel: {},
                rail: {
                  opacity: 0,
                  size: '10px',
                  specifyBorderRadius: false,
                  gutterOfEnds: null,
                  background:'#c9a168',
                  gutterOfSide: '2px',
                  keepShow: false
                },
                bar: {
                  showDelay: 500,
                  onlyShowBarOnScroll: true,
                  keepShow: false,
                  background: '#c9a168',
                  opacity: 1,
                  hoverStyle: false,
                  specifyBorderRadius: false,
                  minSize: 0.2,
                  size: '10px',
                  disable: false,
                },

              },
              bookinfo:{},
              fontSize:16,
              lineHeight:25.6,
              fontRate:1.6,
              mode:1,
              fontColor:'#333',
              fontmode:1
            }
        },
        mounted() {
          this.getBookCon()
          // let _this=this
          // window.onbeforeunload = function(e) {
          //   _this.saveReadInfo()
          //   return 0 ;
          // };
        },

       beforeRouteLeave(to,from,next){
         this.saveReadInfo()
         next()
       },
        methods: {
          saveReadInfo(){
            const { scrollTop, scrollLeft } = this.$refs["vs"].getPosition();
            console.log(scrollTop)
            if(scrollTop>10){
              let cookInfo={
                fontsize:this.fontSize,
                lineheight:this.lineHeight,
                scrolltop:scrollTop,
                mode:this.mode,
                fonttype:this.fontmode,
                id:this.bookinfo.id,
                fontcolor:this.fontColor,
                fontrate:this.fontRate
              }
              window.localStorage['setpage']=JSON.stringify(cookInfo)
            }
          },
          getposition(){
            const { scrollTop, scrollLeft } = this.$refs["vs"].getPosition();
            console.log(scrollTop)
          },
          changeChapt(item){
            this.bookinfo=item
            this.$refs["vs"].scrollTo(
              {
                y: 0
              },
              500,
              "easeInQuad"
            );
          },
          setFontSize(e){
            console.log(this.fontSize)
            this.lineHeight=this.fontSize*this.fontRate
          },
          setLineHeight(){
            console.log(this.fontRate)
            this.lineHeight=this.fontSize*this.fontRate
          },
          setFontType(type){
            console.log(type)
            this.fontmode=type
            if(type==1){
              this.bookinfo.content = simplized(this.bookinfo.content)
              this.bookinfo.className = simplized(this.bookinfo.className)
              this.bookinfo.author = simplized(this.bookinfo.author)
            }else{
              this.bookinfo.content = traditionalized(this.bookinfo.content)
              this.bookinfo.className = traditionalized(this.bookinfo.className)
              this.bookinfo.author = traditionalized(this.bookinfo.author)
            }
          },
          setMode(mode){
            console.log(mode)
            this.mode=mode
            if(mode==0){
              this.fontColor='#bcb6ac'
            }else{
              this.fontColor='#333'
            }
          },
          getBookCon(){
            let _this=this
            this.$http({
              url: '/Book/sonlist',
              method: 'POST',
              headers: {
                'Content-Type': 'application/json'
              },
              data: {id:this.$route.params.id}
            }).then((res) => {
              console.log(res)
              this.loadMode=false
              if(res.data.code==0){
                this.bookData=res.data.data
                this.bookinfo=res.data.data[0]
                // if(window.localStorage['setpage']){
                //   let bookinfo=JSON.parse(window.localStorage['setpage'])
                //   if(this.bookinfo.id==bookinfo.id){
                //     this.$layer.confirm('是否从您上次阅读位置开始阅读',function(){
                //       _this.fontSize=bookinfo.fontsize
                //       _this.lineHeight=bookinfo.lineheight
                //       _this.mode=bookinfo.mode
                //       _this.fontColor=bookinfo.fontcolor
                //       _this.fontRate=bookinfo.fontrate
                //       _this.setFontType(bookinfo.fonttype)
                //       _this.$refs["vs"].scrollTo(
                //         {
                //           y:bookinfo.scrolltop
                //         },
                //         500,
                //         "easeInQuad"
                //       );
                //       _this.$layer.closeAll()
                //     },function(){
                //       _this.$layer.closeAll()
                //     })
                //   }
                // }
              }else{
                this.$layer.msg(res.data.msg)
              }
            })
              .catch((error) => {
                // error
                this.$layer.msg('网络错误，请稍后重试')
                this.loadMode=false
                console.log(error)
              })
          }
        }
    }
</script>
<style lang="scss">
  .vuescroll{
    .__view{
      width:100% !important;
    }
  }

</style>
<style scoped lang="scss">
  .modebg{
    background: url(../../../assets/images/modebg.jpg) #000 no-repeat right bottom !important;
    background-size: 100% 100%;
  }
  .navbg{
    background:rgba(55,53,49,0.7);
  }
  .videoage {
    width: 95rem;
    padding-left: 9rem;
    box-sizing: border-box;
    margin: 0 auto 0;
    position: relative;
    height: 100%;
    .bread_nav {
      padding-top: 2rem;
      .bread_item {
        height: 3rem;
        .tagli {
          height: 3rem;
          font-size: 1.1rem;
          color: #5f4009;
          line-height: 3rem;
        }
        .index {
          background: url("../../../assets/images/nav.png") no-repeat left center;
          background-size: 1rem auto;
          padding-left: 2rem;
        }

        .navcolor{
          color:#ddc394;
        }
        .navcolor.index{
          background: url("../../../assets/images/index2.png") no-repeat left center;
          background-size: 1rem auto;
        }
      }
    }
    .seeting{
      width:100%;
      border-bottom:1px solid #c9a168;
      padding-top:2rem;
      .settxt{
        background: url('../../../assets/images/set.png')no-repeat left center;
        background-size:1.6rem auto;
        padding-left:2.3rem;
        font-size:1.3rem;
        color:#5f4009;
        font-weight: bold;
        height:2rem;
        line-height: 2rem;
      }
      .set2{
        background: url('../../../assets/images/set2.png')no-repeat left center;
        background-size:1.6rem auto;
        color:#ddc394 !important;
      }
      .fonttype{
        font-size:1.3rem;
        color:#5f4009;
        padding:0 0 0 2.8rem;
        height:2rem;
        line-height: 2rem;
      }
      .fonttype1{
        color:#ddc394 !important;
      }
      .fonttype_opt{
        width:5rem;
        height:2rem;
        border:1px solid #c9a168;
        border-radius:3px;
        font-size:1.1rem;
        text-align: center;
        line-height: 2rem;
        color:#333;
        margin-left:0.6rem;
        cursor: pointer;
        box-sizing: border-box;
        background: #fff;
        span{
          line-height: 2rem;
        }
      }
      .select{
        background:#c9a168;
        color:#fff;
      }
      .font-size_txt{
        font-size:1.3rem;
        color:#5f4009;
        padding:0 1.6rem 0 2.8rem;
        height:2rem;
        line-height: 2rem;
      }
      .set-font-size{
        width:7rem;
        height:2rem;
        position: relative;
        input{
          width:7rem;
          border:1px solid #c9a168;
          border-radius:3px;
          box-sizing: border-box;
          padding-left:0.7rem;
          font-size:1.1rem;
          color:#333;
          height:2rem;
          outline:none;
        }
        input:focus{
          outline: none;
        }
        .dw{
          position: absolute;
          left:3rem;
          font-size: 1.1rem;
          height:1.2rem;
          line-height: 1.2rem;
          top:50%;
          margin-top:-0.6rem;
        }
      }
      .read-mode{
        width:6.4rem;
      }
      .download{
        background: url('../../../assets/images/downbook.png')no-repeat left center;
        background-size:1.6rem auto;
        padding-left:2rem;
        color:#5f4009;
        font-size:1.3rem;
        cursor: pointer;
        height:2rem;
        line-height: 2rem;
        span{
          border-bottom:1px solid #5f4009;
          line-height: 2rem;
        }
      }
      .down2{
        background: url('../../../assets/images/down2.png')no-repeat left center;
        background-size:1.6rem auto;
      }
    }
    .book-content{
      margin-top:2.9rem;
      position: absolute;
      top:9rem;
      left:9rem;
      width: calc(100% - 9rem);
      /*width:100%;*/
      bottom:0;
      .chapter{
        width:20%;
        height:75%;
        .list_txt{
          font-size:1.3rem;
          color:#5f4009;
          padding:2.5rem 0 1rem;
        }
        .bookimg{
          img{
            max-width:9.5rem;
            height:14rem;
            display: block;
          }
        }
        .chaptlist{
          height:60%;

          ul{
            margin-bottom:20px;
          }
          li{
            font-size:1.1rem;
            color:#5f4009;
            cursor: pointer;
            margin-top:1rem;
            background:url('../../../assets/images/disc.png')no-repeat left center;
            span{
              border-bottom:1px solid #5f4009;
              margin-left:1rem;
              color:#5f4009;
            }
            .color2{
              border-bottom:1px solid #ddc394;
            }
          }
          .active{
            color:#c9a168;
            span{
              border-bottom:1px solid #c9a168;
              color:#c9a168;
            }
            .color2{
              color:#e4d7c6 !important;
              border-color:#e4d7c6;
            }

          }
        }
      }
      .bookmain{
        width:80%;
        height:100%;
        .file-title{
          text-align: center;
          font-size:1.7rem;
          padding-bottom:1rem;
        }
        .author{
          text-align: center;
          font-size:1.1rem;
          position: relative;
        }

        .date{
          font-size:1.1rem;
          position: absolute;
          top:0;
          right:0;
        }
        .book-content-txt{
          padding:2rem 0 0 2rem;
          box-sizing: border-box;
          height:calc(100% - 7rem);
          .filedom{

          }
        }
      }
    }
    .color2{
      color:#ddc394 !important;
    }

  }
  .modebg{
    .chaptlist{
      li{
        background:url('../../../assets/images/chaptbg.png')no-repeat left center !important;
      }
      .active{
        background:url('../../../assets/images/actdisc.png')no-repeat left center !important;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/views/pc/book/detail.vue